import { Col, Container, Row } from 'react-bootstrap'
import travelObject from '@/entities/travel/interface'
import IntroBlockLeadText from '@/components/models/travel/IntroBlock/IntroBlockLeadText'
import IntroBlockHighlights from '@/components/models/travel/IntroBlock/IntroBlockHighlights'
import TitleDecoration from '@/components/cms/TitleDecoration'

interface Props {
  travel: travelObject
}

const IntroBlock = ({ travel }: Props) => {
  return (
    <>
      <div className={'root mb-5'}>
        <Container>
          <Row className={'mb-3'}>
            <Col>
              <TitleDecoration />
            </Col>
          </Row>
          <Row>
            <Col xl={4}>
              <IntroBlockHighlights highlights={travel.highlights} />
            </Col>
            <Col>
              <IntroBlockLeadText travel={travel} />
            </Col>
          </Row>
        </Container>
      </div>
      <style jsx>{`
        .root {
          margin-top: 2rem;
        }
      `}</style>
    </>
  )
}

export default IntroBlock
